import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LibApiBaseService, LibHttpErrorHandler } from 'ngx-mat-base-comp';
import moment from 'moment';
import { interval } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Log } from './Log.model';

@Injectable({
  providedIn: 'root'
})
export class LogService extends LibApiBaseService<Log> {

  private messages: Log[] = [];

    constructor(http: HttpClient, 
      libHttpErrorHandler: LibHttpErrorHandler,
      ) {
      super(
        http,
        libHttpErrorHandler,
        environment.baseURLHubAPI,
        'Log'
      );
      const intervalTime = moment.duration(environment.logBackendInterval || 5, 'minutes').asMilliseconds();
      interval(intervalTime).subscribe(async () => {
        this.sendErrorsToBackend(); 
      });
    }

     sendConsoleError(message?: any, ...optionalParams: any[]) {
       if (message) {
        const jsonMsg = JSON.stringify({message: message, details: optionalParams});
        const msg = btoa(jsonMsg);
        const log = new Log({message: msg, statusCode: -1});
        this.messages.push(log);
       }
    }

    sendErrorsToBackend(){
      if (this.messages.length > 0) {
        const messages = JSON.stringify(this.messages);
        this.Post(messages, 'LogError').toPromise();
        this.messages = [];
      }
    }
}

